export default "__VITE_ASSET__XOQliRjf__"